import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['siSelect', 'dongSelect'];
  static values = { si: String, dong: String };

  async connect() {
    /* 시목록 세팅    
      선택순서
      - 시군구 (선택안한 상태)
      - ...
      - 기타 (동없음)
    */
    this.siSelectTarget.appendChild(this.getBlankOption());
    const siList = await fetch(`/ajax/residence`).then((response) => response.json());
    siList.forEach((si) => {
      const option = document.createElement('option');
      option.innerHTML = si;
      // 디폴트값이 존재하는 경우
      option.selected = si === this.siValue;
      this.siSelectTarget.appendChild(option);
    });
    const etc = this.getETCSiOption();
    etc.selected = etc.value === this.siValue;
    this.siSelectTarget.appendChild(etc);

    if (this.siValue) {
      this.onSiChange({ target: { value: this.siValue } });
    } else {
      this.onSiChange({ target: { value: this.siSelectTarget.value } });
    }
  }

  async onSiChange(event) {
    // 동목록 세팅

    this.dongSelectTarget.innerHTML = '';
    this.dongSelectTarget.appendChild(this.getBlankOption());

    // 선택된 시가 없는경우 동목록 숨김
    if (!event.target.value) {
      this.dongSelectTarget.setAttribute('hidden', true);
      return;
    }

    const dongList = await fetch(`/ajax/residence/${event.target.value}`).then((response) => response.json());

    // 시에 속한 동이 없는 경우 동목록 숨김
    if (!dongList || dongList.length == 0) {
      this.dongSelectTarget.setAttribute('hidden', true);
      return;
    }

    this.dongSelectTarget.removeAttribute('hidden');

    dongList.forEach((dong) => {
      const option = document.createElement('option');
      option.innerHTML = dong;
      // 디폴트값이 존재하는 경우
      option.selected = dong == this.dongValue;
      this.dongSelectTarget.appendChild(option);
    });
  }

  getBlankOption() {
    const option = document.createElement('option');
    option.value = '';
    option.innerHTML = '선택';
    return option;
  }

  getBlankDongOption() {
    const option = document.createElement('option');
    option.value = '';
    option.innerHTML = '읍면동';
    return option;
  }

  getBlankSiOption() {
    const option = document.createElement('option');
    option.value = '';
    option.innerHTML = '시군구';
    return option;
  }

  getETCSiOption() {
    const option = document.createElement('option');
    // 유효성 체크시 시(si)가 ETC 인경우 dong에 공백 허용
    option.innerHTML = '기타';
    return option;
  }
}
